import { useTheme, styled, Button, SxProps } from "@mui/material";
import { StyleguideSavioColors } from "../../../site/configuration/themeSettings";

export const StyledButton = styled(Button, {
    label: "snackbar-button",
})(({ theme: Theme }) => ({
    borderWidth: 2,
    borderColor: StyleguideSavioColors.white,
    color: StyleguideSavioColors.white,
    fontSize: 14,
}));

export const TitleDialog = styled("h2", { label: "TitleDialog" })(({ theme }) => ({
    color: 'inherit',
    marginTop: 0,
    textAlign: 'left',
    fontSize: 20,
    marginBottom: 6,

})
);


export const useClassesSnackBar = (props: any) => {
    const classes = {

        root: {
            backgroundColor: StyleguideSavioColors.greenOkSnackBar,
            "& .MuiSnackbarContent-message": {
                maxWidth: "450px",
            },
        } as SxProps,
        rootError: {
            backgroundColor: StyleguideSavioColors.errorBackground,
        } as SxProps,
    };
    return classes;
};
